import { AgentCategory } from "~/shared/enums";
import type { AgentConfig } from "~/shared/types";
import { validateGithubRepository, validateIsNotEmpty } from "~/utils/validation";

import AgentIcon from "./AgentIcon.vue";
import Icon from "./Icon.vue";

const config: AgentConfig = {
  name: "Jules",
  category: AgentCategory.CODING,
  icon: Icon,
  agentIcon: AgentIcon,
  color: "#715cd7",
  description: "Send Jules bugs, refactors, and cleanup tasks, then come back to a clear plan and diff",
  descriptionMarkdown: `## Overview

Delegate coding work to Jules, Google's async coding agent for GitHub repositories. Dart starts a Jules run from your task, links you back to the run, and completes the task when Jules finishes the work or opens a pull request.

Jules only works with repositories you've already connected in [Jules](https://jules.google/). You can review the API capabilities and setup details in the [official Jules API docs](https://developers.google.com/jules/api).

## Setup guide

1. Open Jules and connect the GitHub repository you want Dart to use
2. Create an API key from Jules settings
3. Open Dart settings, go to Agents, and choose Jules
4. Paste your API key and GitHub repo (accepted formats: \`owner/repo\`, \`https://github.com/owner/repo\`, or \`git@github.com:owner/repo.git\`)
5. Click Set up, then assign coding tasks to Jules from Dart`,
  configFields: [
    {
      key: "apiKey",
      type: "password",
      label: "Jules API key",
      placeholder: "Your Jules API key",
      validate: validateIsNotEmpty,
    },
    {
      key: "repository",
      type: "text",
      label: "GitHub repo",
      placeholder: "owner/repository",
      validate: validateGithubRepository,
    },
  ],
};

export default config;
